import { connect } from 'react-redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { addContentFavorite, removeContentFavorite } from '~src/favorites/actions/FavoritesActions';
import { populateContentBreadcrumbs } from '~src/spacesPlatform/components/breadcrumbs/BreadcrumbHelpers';
import { FlowSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { CompositeSessionInfoSelectors, SessionSiteSelectors } from '../../bootstrap/redux/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { selectCatalogingOnSiteEnabled } from '../../catalog/selectors/CatalogSelectors';
import { enterFlowSubspace } from '../actions/EnterFlowSubspaceAction';
import { FlowDetailWithUsageInfo } from '../models/FlowInfo';
import { selectSchedulingFlowsEnabled } from '../selectors/FlowSelectors';
import { FlowSpace, FlowSpaceDispatchProps, FlowSpaceOwnProps, FlowSpaceStateProps } from './FlowSpace';

const mapStateToProps: MapStateToProps<FlowSpaceStateProps> = (state) => ({
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
  schedulingFlowsEnabled: selectSchedulingFlowsEnabled(state),
  urls: siteUrlsSelector(state),
  areUsersVisible: !CompositeSessionInfoSelectors.isLimitedUserVisibilityEnforced(state),
  flowOutputSubscriptionsEnabledOnSite: SessionSiteSelectors.isFlowOutputSubscriptionsEnabled(state)
});

const mapDispatchToProps: MapDispatchToProps<FlowSpaceDispatchProps, FlowSpaceOwnProps> = (dispatch, ownProps) => ({
  enterSpace: (flowDetailInfo?: FlowDetailWithUsageInfo) => {
    dispatch(enterFlowSubspace(
      flowDetailInfo ?? ownProps.flowDetailInfo,
      ownProps.subplaceName as FlowSubspaceName
    ));
  },
  addToFavorites: () => {
    dispatch(addContentFavorite(ownProps.flowDetailInfo));
  },
  removeFromFavorites: () => {
    dispatch(removeContentFavorite(ownProps.flowDetailInfo));
  },
  populateContentBreadcrumbs,
});

export const ConnectedFlowSpace = connect(mapStateToProps, mapDispatchToProps)(FlowSpace);
